import { render, staticRenderFns } from "./SingleDeviceDashboard.vue?vue&type=template&id=37908419&scoped=true"
import script from "./SingleDeviceDashboard.vue?vue&type=script&lang=js"
export * from "./SingleDeviceDashboard.vue?vue&type=script&lang=js"
import style0 from "./SingleDeviceDashboard.vue?vue&type=style&index=0&id=37908419&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37908419",
  null
  
)

export default component.exports